var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"p-0 m-0",attrs:{"fluid":""}},[_vm._t("fluid"),_c('b-row',[_c('b-col',{staticClass:"d-flex align-items-center",attrs:{"cols":"12","lg":"10","offset-lg":"1"}},[_vm._t("default")],2)],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }